export default __webpack_public_path__ + "static/media/confirmation_check.24216c3d.gif";